import React from 'react';
import Title from '../../title';
import Loading from '../../loading';
import Server from '../../../functions/server';
import $ from "jquery";
import HighlightOff from '@material-ui/icons/HighlightOff';
import Equalizer from '@material-ui/icons/Equalizer';
import { Icon, Button, Form, TextArea } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Transfer from '../Journal/transfer';
import CanceledInvoice from '../Receipt/canceledreceipt';
import Changemode from '../Receipt/changemode';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';

class Payments extends React.Component {

  state = {
    payments: [], fromDate: this.getFormatedDate(new Date(), 'fromDate'),
    toDate: this.getFormatedDate(new Date(), 'toDate'),
    opening: 0, closing: 0, paymentmode: [], menuPermission: []
  }

  componentDidMount() {
    this.getMenuControl()
  }

  getMenuControl() {
    let menuPermission = Permission('payment', this.props.menus);
    if (menuPermission.view) {
      this.getAllPayments();
      this.getTransactionmode();
    }
    this.setState({ menuPermission })
  }


  getTransactionmode() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    $.ajax({
      type: 'POST',
      data: { 'executiveid': userId },
      url: Server() + 'modecontrol/getmode.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data); context.setModes(data);
          context.setState({ paymentmode: data })
        } catch (e) {
        }
      },
      error: function(e) {
        alert('Try again!!')
      }
    });
  }

  setModes(data) {
    let context = this;
    var mode = [];
    data.map((y) => { mode.push({key: y.mode, text: y.mode, value: y.mode}); });
    context.setState({ allModes: data, modeOption: mode });
  }

  getAllPayments() {
    let context = this;
    context.setState({ load: true })
    $.ajax({
      type: 'POST', data: { fromDate: context.state.fromDate, toDate: context.state.toDate },
      url: Server() + 'payment/getAllPayments.php',
      success: function(payments) {
        try {
          payments = JSON.parse(payments);
          context.setState({ payments, load: false })
        } catch (e) {
          console.log(e);
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  makeINTODecimal(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = '';
    }
    return value;
  }

  cancel() {
    let context = this;
    let  { reason, cancelId, cancelType } = this.state;
    $.ajax({
      type: 'POST', data: { id: cancelId, table: cancelType, reason },
      url: Server() + 'payment/cancel.php',
      success: function(data) {
        if (data == 1) {
          let payments = context.state.payments;
          let newPayments = [];
          payments.map((c) => {
            if (c.id == cancelId && c.type == cancelType) {
            }
            else {
              newPayments.push(c);
            }
          })
          context.setState({ payments: newPayments, cancelDilog: false, reason: '' })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  handleChange1 = name => event => {
    this.setState({ [name]: event.target.value })
  }


  render() {
    let sino = 1;
    let closingBalance = 0;
    return (
      <div>
        <Title title={'Payment'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>
              <div style={{display: 'flex'}}>
                  <div style={{marginLeft: 5}}>
                      From Date<br/>
                      <input type="date" id="date" value={this.state.fromDate}
                      style={{height: 35 }} onChange={ (event) => { this.setState({ fromDate: event.target.value }) }} />
                  </div>
                  <div style={{marginLeft: 5}}>
                      To Date<br/>
                      <input type="date" id="date" value={this.state.toDate}
                      style={{height: 35 }} onChange={ (event) => { this.setState({ toDate: event.target.value }) }} />
                  </div>
                  <div style={{marginLeft: 5}}>
                      <br/>
                      <Button onClick={this.getAllPayments.bind(this)}>Submit</Button>
                  </div>
                  <div>
                    <br/>
                    { this.state.menuPermission.add ?
                      (
                        <Transfer type="Ledger" transferControl={this.props.transferControl}  />
                      ):''
                    }
                  </div>
                  <div>
                    <br/>
                    <CanceledInvoice name={'Cancelled Payment'} type="Payment" />
                  </div>
              </div>
              <div style={{margin: '10px'}}>
                  <table width="100%" id="table">
                      <tr id="th">
                          <th id="th">Sino</th>
                          <th id="th">Payment Voucher</th>
                          <th id="th">Date</th>
                          <th id="th">Name</th>
                          <th id="th">Amount</th>
                          <th id="th">Mode</th>
                          <th id="th">Status</th>
                          <th id="th">Cancel</th>
                      </tr>
                      { 
                          this.state.payments.map((c) => {
                              let amount = this.convertIntoNumber(c.amount);
                              
                              if (amount < 0) {
                                  amount = amount * -1;
                              }
                              amount = this.makeINTODecimal(amount);
                              return (
                                  <tr>
                                      <td>{sino++}</td>
                                      <td>{c.voucher}</td>
                                      <td>{c.date}</td>
                                      <td>{c.name}</td>
                                      <td><div style={{textAlign: 'right'}}>{amount}</div></td>
                                      <td>
                                        <Changemode mode={c.mode} paymentmode={this.state.paymentmode} from={'payment'} type={c.type}
                                                    id={c.id} data={this.state.payments} updateData={this.getAllPayments.bind(this)} />
                                  
                                      </td>
                                      <td>{c.status}</td>
                                      <td onClick={ () => 
                                        { 
                                          if (!this.state.menuPermission.cancel) {
                                            alert('You Are Not Allow To Cancel!!!');
                                            return;
                                          }
                                          this.setState({ cancelDilog: true, cancelId: c.id, cancelType: c.type }) 
                                        } }>Cancel</td>
                                  </tr>
                              )
                          })
                      }
                  </table>
              </div>
              </div>
          ):
          (
            <center>You Are Not Allow To Access This Menu!!!</center>
          )

        }
        

        <Dialog fullWidth={true} maxWidth={'sm'}
          open={this.state.cancelDilog} onClose={ () => { this.setState({ cancelDilog: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Reason</DialogTitle>
          <DialogContent>
              Reason<br/>
              <Form>
                <TextArea value={this.state.remark} onChange={this.handleChange1('reason')} fluid />
              </Form>
          </DialogContent>
          <DialogActions>
               <Button onClick={  () => { this.setState({ cancelDilog: false }) } }>Close</Button> 
               <Button onClick={this.cancel.bind(this)}>Submit</Button> 
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Payments;
